<coin-v2-dialog-frame [header]="data.mediaType === 'image' ? 'Select an Image' : 'Select a Video'">
  <div class="body-container">
    <div class="select-container">
      <p class="instruction-text">
        Either directly insert the {{ mediaName }}'s URL or select one of the shown {{ mediaName }}s.
      </p>
      <div class="inner-select-container">
        @if (!isLoading && !selectedMediaUrl) {
          <div class="image-details">
            <p class="no-selection-text">... No {{ mediaName }} selected ...</p>
          </div>
        }
        @if (!isLoading && selectedMediaUrl) {
          <div class="preview-image">
            @if (data.mediaType === 'image') {
              <img [src]="selectedMediaUrl" />
            } @else {
              <video
                controls
                [src]="selectedMediaUrl"></video>
            }

            <coin-gmm-spacer></coin-gmm-spacer>

            <div class="usage-preview-container">
              @if (cmsUsages) {
                <coin-cms-image-usages
                  [usages]="cmsUsages"
                  [isImageUsed]="isMediaUsed"></coin-cms-image-usages>
              }
              @if (isUsageLoading) {
                <div class="usage-spinner-container">
                  <mat-spinner></mat-spinner>
                </div>
              }
            </div>
          </div>
        }

        @if (isLoading) {
          <div class="loading-container">
            <mat-spinner></mat-spinner>
          </div>
        }

        <div class="select-or-search-thumbnail">
          <mat-form-field>
            <mat-label>{{ (data.mediaType === 'image' ? 'cms.image-url' : 'cms.video-url') | translate }}</mat-label>
            <input
              matInput
              aria-label="media url"
              type="test"
              [placeholder]="'https://...'"
              [required]="true"
              [(ngModel)]="selectedMediaUrl" />
          </mat-form-field>

          <div class="scrollable-thumbnail-container">
            @for (thumbnailUrl of thumbnailUrls; track thumbnailUrl) {
              <div>
                <div class="thumbnail-container">
                  <div
                    class="thumbnail-img"
                    [ngStyle]="{ background: 'url(' + thumbnailUrl + ')' }"
                    (click)="selectMedia(thumbnailUrl)"></div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <coin-v2-dialog-footer color="white">
    <div class="image-actions">
      <coin-v2-button
        [type]="'secondary'"
        [icon]="'upload'"
        [iconPos]="'right'"
        [text]="'general.btnUpload' | translate"
        (click)="fileInput.click()"></coin-v2-button>
      <coin-v2-button
        [type]="'secondary'"
        [icon]="'list'"
        [iconPos]="'right'"
        [disabled]="!this.selectedMediaUrl || this.isUsageAlreadyCalculated"
        [text]="'cms.emails.calculate-usages' | translate"
        (click)="calculateUsageClickHandler(selectedMediaUrl)"></coin-v2-button>
      <coin-v2-button
        [type]="'secondary'"
        [icon]="'delete'"
        [iconPos]="'right'"
        [disabled]="!this.selectedMediaUrl"
        [text]="'general.btnDelete' | translate"
        (click)="deleteMedia(selectedMediaUrl)"></coin-v2-button>
    </div>
    <div class="dialog-actions">
      <input
        #fileInput
        hidden
        type="file"
        id="mediaInput"
        accept="*"
        (change)="uploadMedia($event)" />
      <coin-gmm-spacer></coin-gmm-spacer>
      <coin-v2-button
        [type]="'secondary'"
        [icon]="'close'"
        [iconPos]="'right'"
        [text]="'general.btnClose' | translate"
        (click)="discard()"></coin-v2-button>
      <coin-v2-button
        [type]="'primary'"
        [icon]="'save'"
        [iconPos]="'right'"
        [disabled]="!selectedMediaUrl"
        [text]="'general.btnConfirm' | translate"
        (click)="confirm()"></coin-v2-button>
    </div>
  </coin-v2-dialog-footer>
</coin-v2-dialog-frame>
